import React, { useEffect } from 'react';
import { trackFetchErrors } from '@atlassian/jira-errors-handling';
import {
	FeedbackCollectorButton,
	EntryKeys,
	ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT,
} from '@atlassian/jira-feedback-collector';
import { useResource } from '@atlassian/jira-router';
import {
	type ProjectContext,
	projectContextResource,
} from '@atlassian/jira-router-resources-project-context';
import {
	hideUGCProviderName,
	useDeploymentProviders,
} from '@atlassian/jira-software-deployments-devops-provider';
import {
	resourceResultToServiceQueryResult,
	type ServiceQueryResult,
} from '@atlassian/jira-software-deployments-service-query-types';

const FEEDBACK_COLLECTOR_LOCATION = 'deployments.page.header';

export const useProjectContextServiceQueryResult = (): ServiceQueryResult<ProjectContext> =>
	resourceResultToServiceQueryResult<ProjectContext>(useResource(projectContextResource));

export const FeedbackButton = () => {
	const { data: project } = useProjectContextServiceQueryResult();
	const { data: deploymentProviders, error: errorDeploymentProvider } = useDeploymentProviders();

	useEffect(() => {
		if (errorDeploymentProvider) {
			trackFetchErrors({
				error: errorDeploymentProvider,
				id: 'retrieveContexts',
				packageName: 'jiraSoftwareDeploymentsFeedbackButton',
				logToSentry: true,
			});
		}
	}, [errorDeploymentProvider]);

	const additionalFeedbackEntries = [
		{
			id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION,
			value: FEEDBACK_COLLECTOR_LOCATION,
		},
		{
			id: EntryKeys.IS_SIMPLIFIED_PROJECT,
			value: project ? project.simplified.toString() : '',
		},
		{
			id: EntryKeys.IS_ADMIN,
			value: project ? (project.isProjectAdmin ?? false).toString() : '',
		},
		{
			id: EntryKeys.DEPLOYMENT_PROVIDERS,
			value: deploymentProviders
				? hideUGCProviderName(deploymentProviders)
						.map((deploymentProvider) => deploymentProvider.name)
						.join(', ')
				: '',
		},
	];

	return (
		<FeedbackCollectorButton
			entrypointId={ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT}
			feedbackContext={additionalFeedbackEntries}
		/>
	);
};

export default FeedbackButton;
